// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общие стили для контейнера */
.u1DPBSUX3OlMSBJd7GhQ {
  margin-top: 20px;
}

/* Стили для скроллбаров */
.ant-list {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f9f9f9;
}

.ant-list::-webkit-scrollbar {
  width: 6px;
}

.ant-list::-webkit-scrollbar-track {
  background: #f9f9f9;
  border-radius: 3px;
}

.ant-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
  transition: background 0.2s ease;
}

.ant-list::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Стили для контейнеров с прокруткой */
.HqmQGvRqVLtN_FqfJHca {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f9f9f9;
}

.HqmQGvRqVLtN_FqfJHca::-webkit-scrollbar {
  width: 6px;
}

.HqmQGvRqVLtN_FqfJHca::-webkit-scrollbar-track {
  background: #f9f9f9;
  border-radius: 3px;
}

.HqmQGvRqVLtN_FqfJHca::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
  transition: background 0.2s ease;
}

.HqmQGvRqVLtN_FqfJHca::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Заголовки секций */
.tF5P4iUeUe5boOfOSxdJ {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 10px;
}

/* Стили для полей ввода */
.GZ4E1iam7hjS62fZEld9 {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box; /* Учет padding и border в ширине */
}

.GZ4E1iam7hjS62fZEld9:focus {
  border-color: #007bff;
  outline: none;
}

/* Стили для списка полей */
.N42CzrNqukJQnCVQZv4F {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 300px; /* Ограничение высоты списка */
  overflow-y: auto; /* Включение прокрутки по вертикали */
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 10px;
}

/* Стили для каждого поля в списке */
.N37V4v740AF4AL2vCyQU {
  padding: 10px;
  margin-bottom: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  background-color: #ffffff;
  transition: background-color 0.3s, border-color 0.3s;
  color: #333; /* Более темный цвет текста */
}

.N37V4v740AF4AL2vCyQU:hover {
  background-color: #f1f1f1;
}

.N37V4v740AF4AL2vCyQU.MAjvGRNmsqqLSutLsPzf {
  background-color: #e6f7ff; /* Цвет выделенного поля */
}

/* Стили для кнопки "Создать кастомное поле" и "Сохранить изменения" */
.xD_8UCS7meJ3Ce8EOR9u {
  padding: 10px 20px;
  background-color: #007bff;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-bottom: 10px;
}

.xD_8UCS7meJ3Ce8EOR9u:hover {
  background-color: #0056b3;
}

.xD_8UCS7meJ3Ce8EOR9u:active {
  background-color: #004085;
}

.xD_8UCS7meJ3Ce8EOR9u:focus {
  outline: none;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

/* Стили для кнопки удаления кастомного поля */
.K3Sj54h9WNCRHVVoo8iT {
  color: #ff0000;
  cursor: pointer;
  margin-left: 10px;
}

.K3Sj54h9WNCRHVVoo8iT:hover {
  text-decoration: underline;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 768px) {
  .GZ4E1iam7hjS62fZEld9 {
    padding: 6px;
  }

  .xD_8UCS7meJ3Ce8EOR9u {
    width: 100%;
    padding: 12px;
  }
}

.Z9Zg143fwFfZW7nIMvqd {
  margin-right: 10px;
  margin-left: 10px;
  cursor: pointer;
  color: #007bff;
}

.NsNa7EASCgv_sd775ipS {
  background: transparent;
  border-bottom: 1px solid #007bff;
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsWindow/ChecklistEditor.module.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB,EAAE,mCAAmC;AAC7D;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,iBAAiB,EAAE,8BAA8B;EACjD,gBAAgB,EAAE,qCAAqC;EACvD,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oDAAoD;EACpD,WAAW,EAAE,6BAA6B;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yCAAyC;AACzC;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;AAClC","sourcesContent":["/* Общие стили для контейнера */\n.checkListEditor {\n  margin-top: 20px;\n}\n\n/* Стили для скроллбаров */\n:global(.ant-list) {\n  scrollbar-width: thin;\n  scrollbar-color: #c1c1c1 #f9f9f9;\n}\n\n:global(.ant-list::-webkit-scrollbar) {\n  width: 6px;\n}\n\n:global(.ant-list::-webkit-scrollbar-track) {\n  background: #f9f9f9;\n  border-radius: 3px;\n}\n\n:global(.ant-list::-webkit-scrollbar-thumb) {\n  background: #c1c1c1;\n  border-radius: 3px;\n  transition: background 0.2s ease;\n}\n\n:global(.ant-list::-webkit-scrollbar-thumb:hover) {\n  background: #a1a1a1;\n}\n\n/* Стили для контейнеров с прокруткой */\n.scrollableContainer {\n  scrollbar-width: thin;\n  scrollbar-color: #c1c1c1 #f9f9f9;\n}\n\n.scrollableContainer::-webkit-scrollbar {\n  width: 6px;\n}\n\n.scrollableContainer::-webkit-scrollbar-track {\n  background: #f9f9f9;\n  border-radius: 3px;\n}\n\n.scrollableContainer::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n  transition: background 0.2s ease;\n}\n\n.scrollableContainer::-webkit-scrollbar-thumb:hover {\n  background: #a1a1a1;\n}\n\n/* Заголовки секций */\n.sectionTitle {\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n/* Стили для полей ввода */\n.inputField {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box; /* Учет padding и border в ширине */\n}\n\n.inputField:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n/* Стили для списка полей */\n.fieldList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  max-height: 300px; /* Ограничение высоты списка */\n  overflow-y: auto; /* Включение прокрутки по вертикали */\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  margin-bottom: 10px;\n}\n\n/* Стили для каждого поля в списке */\n.fieldItem {\n  padding: 10px;\n  margin-bottom: 5px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  cursor: pointer;\n  background-color: #ffffff;\n  transition: background-color 0.3s, border-color 0.3s;\n  color: #333; /* Более темный цвет текста */\n}\n\n.fieldItem:hover {\n  background-color: #f1f1f1;\n}\n\n.fieldItem.selected {\n  background-color: #e6f7ff; /* Цвет выделенного поля */\n}\n\n/* Стили для кнопки \"Создать кастомное поле\" и \"Сохранить изменения\" */\n.saveButton {\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: #ffffff;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  margin-bottom: 10px;\n}\n\n.saveButton:hover {\n  background-color: #0056b3;\n}\n\n.saveButton:active {\n  background-color: #004085;\n}\n\n.saveButton:focus {\n  outline: none;\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n}\n\n/* Стили для кнопки удаления кастомного поля */\n.deleteButton {\n  color: #ff0000;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.deleteButton:hover {\n  text-decoration: underline;\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 768px) {\n  .inputField {\n    padding: 6px;\n  }\n\n  .saveButton {\n    width: 100%;\n    padding: 12px;\n  }\n}\n\n.editButton {\n  margin-right: 10px;\n  margin-left: 10px;\n  cursor: pointer;\n  color: #007bff;\n}\n\n.editInput {\n  background: transparent;\n  border-bottom: 1px solid #007bff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkListEditor": `u1DPBSUX3OlMSBJd7GhQ`,
	"scrollableContainer": `HqmQGvRqVLtN_FqfJHca`,
	"sectionTitle": `tF5P4iUeUe5boOfOSxdJ`,
	"inputField": `GZ4E1iam7hjS62fZEld9`,
	"fieldList": `N42CzrNqukJQnCVQZv4F`,
	"fieldItem": `N37V4v740AF4AL2vCyQU`,
	"selected": `MAjvGRNmsqqLSutLsPzf`,
	"saveButton": `xD_8UCS7meJ3Ce8EOR9u`,
	"deleteButton": `K3Sj54h9WNCRHVVoo8iT`,
	"editButton": `Z9Zg143fwFfZW7nIMvqd`,
	"editInput": `NsNa7EASCgv_sd775ipS`
};
export default ___CSS_LOADER_EXPORT___;
